<template>
    <div class="addcontract">
        <header class="text-xs-center white--text">
            <h2>Versicherungstyp wählen</h2>
            <p v-if="is_offer">Wünschen Sie ein Angebot für Ihr Unternehmen oder zur Absicherung von privaten Risiken?</p>
            <p v-else>Wählen Sie bitte den Versicherungsbereich von Ihrem Vertrag aus.</p>
        </header>

        <v-layout row wrap class="mt-4">
            <v-flex class="xs12 md6 lg4 offset-lg2 px-2 mt-3">
                <v-card light hover to="./company">
                    <div class="pa-3 text-xs-center">
                        <v-avatar size="7rem"><v-icon class="icon">business</v-icon></v-avatar>
                        <div class="headline mb-2">Unternehmen</div>
                        <div>
                            <p v-if="is_offer">Angebot für Ihr Unternehmen, als Selbstständiger oder Freiberufler.</p>
                            <p v-else>Versicherungsvertrag für Unternehmen, Selbstständige und Freiberufler.</p>
                        </div>
                    </div>
                </v-card>
            </v-flex>
            <v-flex class="xs12 md6 lg4 px-2 mt-3">
                <v-card light hover to="./private">
                    <div class="pa-3 text-xs-center">
                        <v-avatar size="7rem"><v-icon class="icon">accessibility</v-icon></v-avatar>
                        <div class="headline mb-2">Privat</div>
                        <div>
                            <p v-if="is_offer">Versicherungsangebot für private oder familiäre Risiken erhalten.</p>
                            <p v-else>Versicherungsvertrag für private oder familiäre Absicherung hinzufügen.</p>
                        </div>
                    </div>
                </v-card>
            </v-flex>
            <v-flex v-if="is_offer" class="xs12 md6 lg4 offset-lg4 px-2 mt-3">
                <v-card light hover :disabled="has_needrequest==1" @click="getNeedDialouge" :class="has_needrequest==1 ? 'opa50' : ''">
                    <div class="pa-3 text-xs-center">
                        <v-avatar size="7rem"><v-icon class="icon">fingerprint</v-icon></v-avatar>
                        <div class="headline mb-2">Bedarfsanalyse</div>
                        <div>
                            <p>Welche Versicherung ist für mich und mein Unternehmen wichtig?</p>
                        </div>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="needsdialouge" absolute max-width="600">
            <v-card>
                <v-card-title class="headline">Bedarfsanalyse</v-card-title>
                <v-card-text>
                    <p>Sie erhalten von einem unserer Versicherungsexperten eine Risikoanalyse für Ihr Unternehmen und / oder für Ihren privaten Gebrauch.</p>
                    <ul class="checks">
                        <li>Welche Versicherung ist notwendig &amp; nützlich?</li>
                        <li>Beratung via Telefon, Chat oder Videoanruf</li>
                        <li>Individuell, kostenfrei &amp; unverbindlich</li>
                    </ul>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn flat @click="needsdialouge = false">Abbrechen</v-btn>
                    <v-spacer />
                    <v-btn color="black" dark @click="getNeedAnalysis">Kostenfreie Analyse erhalten</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    data: () => ({
        needsdialouge: false,
        has_needrequest: 1
    }),


    computed: {
        is_offer(){
            return this.$route.name=='addoffer'
        },
        is_check(){
            return this.$route.name=='addtariffcheck'
        }
    },


    created: function(){
        if(this.$store.state.user.data.has_needrequest==1){
            if(this.$store.state.user.data.needrequest_published_date!=null){
                if(this.$moment().diff(this.$store.state.user.data.needrequest_published_date, 'days')>14){
                    this.has_needrequest = 0;
                    this.$store.dispatch('user/setNeedRequest', 0);
                }
            }else{
                this.has_needrequest = 0;
                this.$store.dispatch('user/setNeedRequest', 0);
            }
        }else{
            this.has_needrequest = 0;
        };
    },


    methods: {
        getNeedDialouge(){
            if(!this.has_needrequest){
                this.needsdialouge = true;
            }
        },

        getNeedAnalysis(){
            if(!this.has_needrequest){
                this.has_needrequest = true;
                this.$store.dispatch('user/setNeedRequest', true);
                this.$snotify.success('Bedarfsanalyse angefragt');
                this.needsdialouge = false;
            };
        }
    }
}
</script>


<style scoped>
    .icon{
        font-size:7rem;
    }
    .opa50{
        cursor: not-allowed;
    }
    .v-progress-linear{
        margin: 0;
    }
</style>